export default {
    computed: {
        loadPageCriteria() {
            const criteria = this.$super('loadPageCriteria');

            criteria
                .getAssociation('sections')
                .getAssociation('blocks')
                .addAssociation('swagCmsExtensionsQuickview');

            return criteria;
        },
    },
}
